import React, { useState } from "react";
import styles from "./searchPage.module.css";

import Topbar from "../../components/topbar/Topbar";
import { makeStyles } from "@material-ui/core/styles";

// Redux stuff
import { connect } from "react-redux";

// Material Ui Components
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";

// Material Ui Icons
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = ["Profile", "Project", "Tag", "Event"];

function SearchPage() {
    const classes = useStyles();
    const [personName, setPersonName] = useState([]);

    // useEffect(() => {
    //     if (
    //         personName.includes("Profile") &&
    //         personName.includes("Project") &&
    //         personName.includes("Tag")
    //     ) {
    //         setPersonName(["All"]);
    //     }
    // }, [personName]);

    const handleChange = (event) => {
        setPersonName(event.target.value);
    };

    return (
        <div>
            <Topbar name={"Events"} buttonText={"Create New"} />
            <div className={styles.container}>
                <div className={styles.searchCardContainer}>
                    <div className={styles.searchContainer}>
                        <div className={styles.left}>
                            <SearchIcon className={styles.searchIcon} />
                            <input
                                className={styles.searchField}
                                type="text"
                                placeholder="Search something..."
                            />
                        </div>
                        <div className={styles.right}>
                            <FormControl
                                className={`${classes.formControl} ${styles.selectCatagoryContainer}`}
                            >
                                {/* <InputLabel id="demo-mutiple-checkbox-label">
                                    Tag
                                </InputLabel> */}
                                <Select
                                    className={styles.selector}
                                    labelId="demo-mutiple-checkbox-label"
                                    id="demo-mutiple-checkbox"
                                    multiple
                                    value={personName}
                                    onChange={handleChange}
                                    input={<Input />}
                                    renderValue={(selected) =>
                                        selected.join(", ")
                                    }
                                    MenuProps={MenuProps}
                                >
                                    {names.map((name) => (
                                        <MenuItem key={name} value={name}>
                                            <Checkbox
                                                checked={
                                                    personName.indexOf(name) >
                                                    -1
                                                }
                                            />
                                            <ListItemText primary={name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <div className={styles.searchButtonContainer}>
                                <button>Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, {})(SearchPage);
